import header from './Header/index'
import footer from './Footer/index'
import rightSidebar from './RightSidebar/index'
import banner from './banner/index'
import productList from './productList/index'
import quickLink from './quickLink/index'
import getArea from './getArea/index'
export default {
  header,footer,rightSidebar,banner,productList,quickLink,getArea
}



// WEBPACK FOOTER //
// ./src/components/index.js